var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{staticStyle:{"margin-top":"16px"}},[_c('span',{staticClass:"subtitle"},[_vm._v("Política de privacidad")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }